import axios from "axios";

const api = axios.create({
  // baseURL: process.env.REACT_APP_BASE_URL,
  baseURL: "https://campusroot.com/",

});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("_auth_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;